import { ProductBeverageItem } from "@hatch-digital-nl/bravilor-storybook";
import { DstBeverageItem } from "../interfaces/ProductDetailViewTypes";

export const mapDstBeveragesForDisplay = (
    beverages: DstBeverageItem[] | undefined,
): ProductBeverageItem[] =>
    (beverages ?? []).map((beverage) => ({
        code: beverage.code,
        label: beverage.label,
        iconUrl: beverage.iconUrl,
    }));
